import * as XLSX from 'xlsx';
import dayjs from 'dayjs';

export const exportLessonsToExcel = (lessons, studentName) => {
  if (!lessons || !lessons.length) {
    return;
  }

  const rows = lessons.map((lesson) => ({
    Дата: dayjs(lesson.date).format('DD.MM.YYYY'),
    Тема: lesson.topic || '',
    Примітки: lesson.notes || '',
    'Домашнє завдання': lesson.homeworkTask || '',
    'Файли ДЗ': (lesson.homeworkFiles || []).map((f) => f.fileName).join(', '),
    'Оцінка за ДЗ': lesson.homeworkScore ?? '',
    Активність: lesson.activityScore ?? '',
    Поведінка: lesson.behaviorScore ?? '',
    'Засвоєння матеріалу': lesson.comprehensionScore ?? '',
    'Підсумковий індекс': lesson.finalScore ?? '',
    Оплата: lesson.paid ? 'Оплачено' : 'Не оплачено',
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Уроки');

  const fileName = `${studentName?.replace(/\s+/g, '_') || 'student'}_lessons_${dayjs().format(
    'YYYYMMDD'
  )}.xlsx`;

  XLSX.writeFile(workbook, fileName);
};



